import { z } from "zod";

export const CompanyEditFormSchema = z.object({
  companyName: z.string().min(1),
  zipCode: z.string().min(1),
  address: z.string().min(1),
  phoneNumber: z.string().min(1),
  faxNumber: z.string().or(z.literal("")),
  email: z.string().email().or(z.literal("")),
  category: z.enum(["shipper", "carrier"]),
});

export type CompanyEditFormSchemaType = z.infer<typeof CompanyEditFormSchema>;
